import fetch from '@/utils/fetch'
// 用户基本信息修改
export function userinfo (data) {
  return fetch({
    url: '/userinfo',
    method: 'post',
    data: {
      gender: data.gender,
      mobile: data.mobile,
      profile: data.profile,
      avatar: data.avatar
    }
  })
}
// 用户搜索
export function userSearch (username) {
  return fetch({
    url: '/userSearch',
    method: 'get',
    params: {
      username: username
    }
  })
}
// 用户搜索
export function publicUserinfo (user_number) {
  return fetch({
    url: '/public/userinfo/' + user_number,
    method: 'get'
  })
}
// 修改密码
export function changePwd (data) {
  return fetch({
    url: '/user/change_pwd',
    method: 'post',
    data: {
      old_password: data.old_password,
      new_password: data.new_password,
      new_password_confirm: data.new_password_confirm,
    }
  })
}

// 申请临时账号
export function applyTempAccount (data) {
  return fetch({
    url: '/tmp_user_apply/create',
    method: 'post',
    data
  })
}

// 申请临时用户发送验证码
export function sendMobileCodeFromApply (data) {
  return fetch({
    url: '/tmp_user_apply/send_mobile_code',
    method: 'post',
    data: {
      mobile: data.mobile
    }
  })
}

// 临时账号延期
export function delayTempAccount (data) {
  return fetch({
    url: '/tmp_user/delay',
    method: 'post',
    data
  })
}

// 临时用户延期发送验证码
export function sendMobileCodeFromDelay (data) {
  return fetch({
    url: '/tmp_user_delay/send_mobile_code',
    method: 'post',
    data: {
      mobile: data.mobile
    }
  })
}

// 查询临时账号
export function searchTempAccount (data) {
  return fetch({
    url: '/tmp_user_apply/user_info',
    method: 'post',
    data
  })
}

// 获取临时用户权限
export function userOperaRights () {
  return fetch({
    url: '/user/get_opera_rights',
    method: 'get',
    params: {
      // rights: ''
      // rights: 'operationFileOrFolder,file/{number},topic/report/create,group,topic/edit,folder/tree,edit/{number},group_role/create,topic/create,topic/delete,topic/comment/delete'
    }
  })
}